import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import en from "./en";
import de from "./de";
import bs from "./bs";

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: { en: { translation: en }, de: { translation: de }, bs: { translation: bs } },
    fallbackLng: "en",
    supportedLngs: ["en", "de", "bs"],
    interpolation: { escapeValue: false },
    detection: { order: ["querystring", "localStorage", "navigator"], lookupQuerystring: "lng", lookupLocalStorage: "eg_lang", caches: ["localStorage"] },
  });

export default i18n;
